import { useMemo } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { EmptyState } from "@/components/app/lists/empty-state";
import { PageHeader } from "@/components/app/shell/page-header";
import { staffFeedApi } from "@/components/app/community/staff-feed-api";
import { ReviewQueue } from "@/routes/_authenticated/community/-components/review-queue";
import { useCommunityBuilding } from "@/routes/_authenticated/community/-components/use-community-building";
import { usePolicy } from "@/lib/policy";

export const Route = createFileRoute("/_authenticated/community/review")({
  component: ReviewPage,
});

/** Family posts held for a moderator, and what people reported. */
function ReviewPage() {
  const { me } = usePolicy();
  const { building, canModerate } = useCommunityBuilding();
  const facilityId = building?.id ?? null;
  const api = useMemo(() => staffFeedApi(facilityId, me.buildings), [facilityId, me.buildings]);
  if (!facilityId) return null;
  return (
    <>
      <PageHeader title="Review queue" />
      {canModerate ? (
        <div className="max-w-150">
          <ReviewQueue facilityId={facilityId} api={api} />
        </div>
      ) : (
        <EmptyState
          title="Not open to you"
          description="Reviewing family posts needs the community moderator permission at this building."
        />
      )}
    </>
  );
}
